module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-08.00ec02b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-08.jpg
// module id = D9++
// module chunks = 1